import { doc, updateDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../../firebase/firebase";

export async function markAssignmentInProgress({
  studentUid,
  packetId,
  currentStatus,
}) {
  if (currentStatus && currentStatus !== "in_progress") {
    return;
  }

  const ref = doc(db, "users", studentUid, "assignments", packetId);

  await updateDoc(ref, {
    status: "in_progress",
    startedAt: serverTimestamp(),
  });
}
